import styles from './index.module.less';
import template from './index.art';
import { IOYButtonProps, IOYButtonState } from "./const";
import OY from '../../types/OY';
import { EEventType } from '../../enums/EEventType';
import { jeact } from '../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYButton extends OY<IOYButtonProps, IOYButtonState> {
  static displayName = 'OYButton';

  static defaultProps: Partial<IOYButtonProps> = {
    icon: '',
    iconPosition: 'right'
  };

  state: IOYButtonState = {
    iconMap: {
      icon_add: 'icon-duoxuan',
      icon_up: 'icon-filterup',
      icon_down: 'icon-filterdown',
      icon_toggle: 'icon-qiehuan'
    },
    iconStyle: ''
  }

  $node = {}

  getDerivedStateFromProps(nextProps: IOYButtonProps, state: IOYButtonState) {
    const { iconColor, iconSize } = nextProps;
    let iconStyle = '';
    if (iconColor) {
      iconStyle += `color:${iconColor};`
    }
    if (iconSize) {
      iconStyle += `font-size:${iconSize}px;`
    }
    return { ...state, iconStyle }
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  setNode() { }

  bindClick() {
    const { link, onClick, _pointer } = this.props;
    if (!link) {
      this.$el.on('click', () => {
        if (typeof onClick === 'string' && _pointer) {
          // eslint-disable-next-line prefer-const
          let [name, params]: any[] = onClick.split('(');
          if (params) {
            params = params.replace(')', '').split(',')
          }
          try {
            this.props._pointer[name](...params)
          } catch (error) {
            console.log('_pointer click handler occur errro')
          }
        } else {
          this.eventEmitter.emit(EEventType.onClick)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OYButton/index.ts